import type { AuditSummary, AuditSeverity } from '@claro/shared';
import { cn } from '@/lib/utils';

const SEVERITY_BG: Record<AuditSeverity, string> = {
  0: 'bg-emerald-500',
  1: 'bg-blue-500',
  2: 'bg-amber-500',
  3: 'bg-orange-500',
  4: 'bg-red-500',
  5: 'bg-red-700',
};

interface FieldHeatmapProps {
  summary: AuditSummary | undefined;
  isLoading: boolean;
  onFieldClick?: (field: string) => void;
}

export function FieldHeatmap({ summary, isLoading, onFieldClick }: FieldHeatmapProps) {
  if (isLoading) {
    return <div className="h-[280px] animate-pulse rounded-lg border bg-card" />;
  }

  if (!summary || summary.fieldBreakdown.length === 0) return null;

  const maxTotal = Math.max(...summary.fieldBreakdown.map(f => f.totalDivergences), 1);

  return (
    <div className="rounded-lg border bg-card p-4">
      <h3 className="mb-3 text-sm font-semibold text-muted-foreground">Campos com mais divergências</h3>
      <div className="flex flex-col gap-2">
        {summary.fieldBreakdown.map((fb) => {
          const pct = (fb.totalDivergences / maxTotal) * 100;
          return (
            <button
              key={fb.field}
              className="group flex items-center gap-3 rounded-md px-2 py-1.5 text-left transition hover:bg-muted/50"
              onClick={() => onFieldClick?.(fb.field)}
            >
              <span className="w-28 shrink-0 text-xs font-medium">{fb.fieldLabel}</span>
              <div className="relative h-4 flex-1 overflow-hidden rounded-full bg-muted">
                <div
                  className={cn('h-full rounded-full transition-all', SEVERITY_BG[fb.criticalCount > 0 ? 5 : fb.significantCount > 0 ? 4 : 2])}
                  style={{ width: `${pct}%` }}
                />
              </div>
              <span className="w-10 shrink-0 text-right text-xs font-bold tabular-nums">
                {fb.totalDivergences}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
